import React from 'react';

import { Navigation } from '../utilities/components/navigation/component';
import { Content } from '../features/certifications/content/component';
import { Footer } from '../utilities/components/footer/component';
import { MESSENGER_APP_ID, MESSENGER_PAGE_ID } from 'utilities/consts';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import SEO from 'utilities/components/seo';

import { Breadcrumbs } from 'utilities/components/breadcrumbs/view';
import { routes } from 'utilities/routes';
import { useSeoTexts } from 'utilities/hooks/useSeoTexts';
import { SeoDecription } from 'features/index/seo-description/view';
import { ContactWidget } from 'utilities/components/contact-widget/view';

const Certifications = () => {
    const setCanonicalLink = () => {
        let relCanonical = '';
        if (typeof window !== 'undefined') {
            relCanonical = `${window.location.origin}${window.location.pathname}`;
        }
        return relCanonical;
    };

    const breadcrumbs = [routes.home, routes.certyfikaty];
    const { metaTitle, metaDescription, description } = useSeoTexts('Certyfikaty');

    return (
        <main className="certifications">
            <SEO
                noindex
                title={ metaTitle || 'Barański Drzwi - Certyfikaty - Deklaracje, oceny i świadectwa badań' }
                description={
                    metaDescription
                    || 'Sprawdź jakie certyfikaty, świadectwa badań i oceny techniczne uzyskaliśmy dla Twojego bezpieczeństwa. Poznaj markę Barański!'
                }
                alt="Certyfikaty"
                canonicalLink={ setCanonicalLink() }
            />
            <Navigation />
            <Breadcrumbs breadcrumbs={ breadcrumbs } />
            <Content />
            <SeoDecription seoDescription={ description } />
            <Footer />
            <MessengerCustomerChat pageId={ MESSENGER_PAGE_ID } appId={ MESSENGER_APP_ID } />
            <ContactWidget />
        </main>
    );
};

export default Certifications;
